// handles read more less button func on testimonials cards
// for grid only, slider is handled with similar setup in splide carousel js (requires on mounted to run properly)
window.addEventListener('load', event => {
    const testimonialsPanels = document.querySelectorAll('.testimonials-panel-grid');

    if (testimonialsPanels.length) {
        for (const panel of testimonialsPanels) {
            const containsReadMoreLessElements = panel.querySelector('[data-read-more-less-toggle]');

            if (containsReadMoreLessElements) {
                panel.addEventListener('click', function (event) {
                    const clickedElement = event.target;

                    if (clickedElement instanceof HTMLElement && clickedElement.hasAttribute('data-read-more-less-toggle')) {
                        clickedElement.closest('[data-read-more]').dataset.readMore = clickedElement.closest('[data-read-more]').dataset.readMore === 'true' ? 'false' : 'true';
                    }
                });

                const handleResize = _throttle(() => {
                    const contentContainers = document.querySelectorAll('[data-read-more]');

                    if (contentContainers.length) {
                        for (const container of contentContainers) {
                            const proseContainer = container.querySelector('.prose');
                            const readMoreLessButton = container.querySelector('[data-read-more-less-toggle]');

                            container.dataset.readMore = 'false';

                            if (proseContainer && readMoreLessButton) {
                                proseContainer.classList.add('!overflow-scroll');
                                if (proseContainer.scrollHeight > proseContainer.clientHeight) {
                                    readMoreLessButton.classList.remove('hidden');
                                }
                                else {
                                    readMoreLessButton.classList.add('hidden');
                                }
                                proseContainer.classList.remove('!overflow-scroll');
                            }
                        }
                    }
                }, 100);

                // resets card on resize, and rechecks if a view more / less button is required.
                handleResize();

                window.addEventListener('resize', handleResize);
            }
        }
    }
});